/**
 * Size distribution of an order line (spec 0031 §4.5).
 * Subcollection: org/{orgId}/sales-order/{salesOrderId}/item/{itemId}/breakdown
 *
 * Materialized only for products with a size grid; products without a grid do not
 * produce breakdown rows. Resolve the repository with context
 * `{ orgId, salesOrderId, itemId }`. Audit via {@link Auditable} / ChildCrudService.
 */
export const SALES_ORDER_ITEM_BREAKDOWN = 'SalesOrderItemBreakdown';
//# sourceMappingURL=sales-order-item-breakdown.js.map